import ptLocale from 'element-ui/lib/locale/lang/pt'
import home from './pt/home'

const pt = {
    language: 'Português',
    message: {
        'home': {
            ...home,
            enterEmail: 'Por favor, insira o e-mail',
            save: 'Salvar',
            saveSuccess: 'Salvo com sucesso',
            pointHistory: 'Histórico de pontos',
            type: 'Tipo',
            remark: 'Observação',
            pendingComment: 'A avaliar',
            commented: 'Avaliado',
            selectDate: 'Selecionar data',
            loginSuccess: 'Login bem-sucedido',
            loginFail: 'Falha no login',
            close: 'Fechar',
            required: 'Obrigatório',
            nickname: 'Apelido',
            enterNickname: 'Por favor, insira um apelido',
            gender: 'Sexo',
            male: 'Masculino',
            female: 'Feminino',
            secret: 'Confidencial',
            birthday: 'Aniversário',
            checkoutLoadFailed: 'Falha ao carregar as informações de pagamento. Tente novamente mais tarde.',
            checkoutErrorTitle: 'Aviso',
            goAddAddress: 'Adicionar endereço de entrega',
            shop_order_selectOrAddAddress: 'Por favor, adicione primeiro um endereço de entrega e defina-o como padrão antes de finalizar a compra.',
            shop_order_cartEmpty: 'O carrinho está vazio, não é possível finalizar a compra.',
            shop_order_cartHasNotActive: 'Há itens não publicados ou inválidos, não é possível finalizar a compra.',
            shop_order_cartHasNotMarketable: 'Há itens removidos, não é possível finalizar a compra.',
            shop_order_cartHasLowStock: 'Estoque insuficiente, não é possível finalizar a compra.',
            shop_order_cartHasExpiredGoods: 'Alguns itens da loja expiraram, não é possível finalizar a compra.',
            shop_order_typeIsNull: 'Tipo de pedido não reconhecido, verifique o tipo do item.',
            shop_order_goodsNotFound: 'As informações do produto não existem ou foram excluídas.',
            shop_order_giftNotForSale: 'Itens de brinde não podem ser comprados diretamente.',
            common_message_badRequest: 'Solicitação inválida, verifique o produto e os parâmetros.',
        },
    },
    '手机号码最小长度为8位': "O tamanho mínimo do número do celular é de 8 dígitos",
    '邮箱账号名称最小长度为6位': "O comprimento mínimo do nome da conta de e-mail é de 6 caracteres",
    '邮箱只能包含英文，数字等字符': "A caixa de correio só pode conter caracteres como inglês e números",
    '请选择正确的收货地址': 'Por favor, selecione o endereço de entrega correto',
    Dict_language_status_0: 'Desativado',
    Dict_language_status_1: 'Ativado',
    Dict_member_label_type_1: 'Etiqueta condicional',
    Dict_member_label_type_2: 'Etiqueta manual',
    Dict_member_level_type_0: 'Nível de consumo (LV)',
    Dict_member_level_type_1: 'Membro pago (VIP)',
    Dict_member_growth_action_type_1: 'Fazer pedido',
    Dict_member_growth_action_type_2: 'Login diário',
    Dict_member_growth_action_type_3: 'Publicar avaliação',
    Dict_member_growth_action_type_4: 'Completar perfil',
    Dict_paid_member_payment_type_0: 'Pagamento com saldo',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Válido',
    Dict_paid_member_record_status_1: 'Expirado',
    Dict_paid_member_record_status_2: 'Reembolsado',
    Dict_point_lottery_prize_type_0: 'Pontos',
    Dict_point_lottery_prize_type_1: 'Cupom',
    Dict_point_lottery_prize_type_2: 'Prêmio físico',
    Dict_point_lottery_prize_type_3: 'Obrigado por participar',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'E-mail',
    Dict_notification_channel_type_2: 'Mensagem interna',
    Dict_notification_channel_type_3: 'Notificação push',
    Dict_announcement_status_0: 'Rascunho',
    Dict_announcement_status_1: 'Publicado',
    Dict_announcement_status_2: 'Removido',
    Dict_live_permission_status_0: 'Não solicitado',
    Dict_live_permission_status_1: 'Em análise',
    Dict_live_permission_status_2: 'Ativado',
    Dict_live_permission_status_3: 'Rejeitado',
    Dict_live_room_status_0: 'Não iniciado',
    Dict_live_room_status_1: 'Ao vivo',
    Dict_live_room_status_2: 'Encerrado',
    Dict_live_room_status_3: 'Interrupção anormal',
    Dict_live_room_type_0: 'Transmissão da plataforma',
    Dict_live_room_type_1: 'Transmissão do comerciante',
    Dict_store_type_0: 'Loja individual',
    Dict_store_type_1: 'Loja empresarial',
    Dict_store_sign_status_0: 'Aguardando assinatura',
    Dict_store_sign_status_1: 'Assinado',
    Dict_store_sign_status_2: 'Rescindido',
    Dict_store_business_change_status_0: 'Aguardando análise',
    Dict_store_business_change_status_1: 'Aprovado',
    Dict_store_business_change_status_2: 'Rejeitado',
    Dict_decoration_page_type_0: 'Página inicial',
    Dict_decoration_page_type_1: 'Página de categoria',
    Dict_decoration_page_type_2: 'Página de campanha',
    Dict_decoration_page_type_3: 'Página personalizada',
    Dict_decoration_status_0: 'Rascunho',
    Dict_decoration_status_1: 'Publicado',
    Dict_decoration_popup_trigger_page_0: 'Início da plataforma',
    Dict_decoration_popup_trigger_page_1: 'Central de membros',
    Dict_decoration_popup_trigger_page_2: 'Pagamento concluído',
    Dict_decoration_popup_target_user_0: 'Todos os usuários',
    Dict_decoration_popup_target_user_1: 'Membros gratuitos',
    Dict_decoration_popup_target_user_2: 'Membros pagos',
    Dict_decoration_popup_frequency_0: 'Uma vez permanentemente',
    Dict_decoration_popup_frequency_1: 'A cada visita',
    Dict_decoration_popup_frequency_2: 'Frequência personalizada',
    Dict_track_event_type_page_view: 'Visualização de página',
    Dict_track_event_type_click: 'Clique',
    Dict_track_event_type_add_to_cart: 'Adicionar ao carrinho',
    Dict_track_event_type_search: 'Pesquisa',
    Dict_track_event_type_purchase: 'Compra',
    Dict_track_event_type_live_watch: 'Assistir ao vivo',
    Dict_reconcile_period_type_0: 'Diário',
    Dict_reconcile_period_type_1: 'Semanal',
    Dict_reconcile_period_type_2: 'Mensal',
    Dict_store_settlement_status_0: 'Aguardando liquidação',
    Dict_store_settlement_status_1: 'Liquidado',
    Dict_distributor_status_0: 'Aguardando análise',
    Dict_distributor_status_1: 'Analisado',
    Dict_distributor_status_2: 'Rejeitado',
    Dict_distribution_commission_type_0: 'Comissão direta',
    Dict_distribution_commission_type_1: 'Comissão indireta',
    Dict_configuration_status_0: 'Desativado',
    Dict_configuration_status_1: 'Ativado',
    ...ptLocale
}
export default pt
